import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhyCFO from "./components/WhyCFO";
import AboutUs from "./components/AboutUs";
import Team from "./components/Team";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import FAQ from "./components/FAQ";
import CounterSection from "./components/CounterSection";
import FullTeam from "./components/FullTeam";
import TeamMember from "./components/Teammember";
import CTAMultiStep from "./components/CTAMultiStep";
import BlogsPage from "./pages/BlogsPage";
import BlogPost from "./pages/BlogPost";
import CaseStudyPost from "./pages/CaseStudyPost";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import { DataProvider } from "./data/DataContext";

import SchemaMarkup from "./components/SchemaMarkup";
import { homeFaqSchema } from "./schemas/homeSchema";
import {
  servicesBreadcrumbSchema,
  servicesFaqSchema,
} from "./schemas/servicesSchema";
import { aboutBreadcrumbSchema, aboutFaqSchema } from "./schemas/aboutSchema";
import { teamBreadcrumbSchema, teamFaqSchema } from "./schemas/teamSchema";

// ✅ Google Analytics Tracker (ADDED)
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-LYPPY9VGZ7", {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
};

// Scroll to top on every route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

// Home page — everything except Services
const Home = () => (
  <>
    <SchemaMarkup pageId="home" schemas={[homeFaqSchema]} />
    <Hero />
    <WhyCFO />
    <Team />
    <CounterSection />
    <Testimonials />
    <FAQ />
    <CTA />
  </>
);

// About Us page (renamed to Why Choose Us)
const AboutUsPage = () => (
  <>
    <SchemaMarkup
      pageId="about"
      schemas={[aboutBreadcrumbSchema, aboutFaqSchema]}
    />
    <AboutUs />
  </>
);

// Services page
const ServicesPage = () => (
  <>
    <SchemaMarkup
      pageId="services"
      schemas={[servicesBreadcrumbSchema, servicesFaqSchema]}
    />
    <Services />
  </>
);

// FullTeam page
const FullTeamPage = () => (
  <>
    <SchemaMarkup
      pageId="team"
      schemas={[teamBreadcrumbSchema, teamFaqSchema]}
    />
    <FullTeam />
  </>
);

function App() {
  return (
    <DataProvider>
      <BrowserRouter>
        <AnalyticsTracker />
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/team" element={<FullTeamPage />} />
          <Route path="/team/:memberId" element={<TeamMember />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/:slug" element={<BlogPost />} />
          <Route path="/case-studies/:slug" element={<CaseStudyPost />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </DataProvider>
  );
}

export default App;
